const MAX_STRING_LENGTH = 30;

/**
 * Tronca una stringa al massimo a `max` caratteri sostituendo l'eccedenza con
 * un'ellissi finale (`…`). Usata per i valori di tipo Text e Custom-string
 * mostrati dentro un chip, dove non c'è spazio per stringhe lunghe.
 */
export function truncateFilterBarString(
  value: string,
  max = MAX_STRING_LENGTH,
): string {
  return value.length > max ? `${value.slice(0, max - 1)}…` : value;
}
